// :cow: Cosmose CONFIDENTIAL :iso:
import * as moment from 'moment';

export const dateFormat = {
  minute: 'mm',
  hour: 'HH',
  time: 'HH:mm',
  date: 'MMM DD, YYYY',
  full: 'DD/MM/YYYY HH:mm'
};

export const datepickerFormat = {
  parse: {
    dateInput: dateFormat.date
  },
  display: {
    dateInput: dateFormat.date,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: dateFormat.date,
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

export const dateFormatter = (date: string, format = dateFormat.date) => {
  return moment(date).format(format);
};
